import * as React from "react";
import * as Scrivito from "scrivito";
import { Helmet } from "react-helmet-async";
import { getMetadata } from "utils";
import favicon from "assets/images/favicon.png";

type PageMetadata = { name?: string; content: string; property?: string };

type PageLinks = { rel: string; type?: string; href: string };

export const CurrentPageMetadata = Scrivito.connect(() => {
  let lang = "en";
  let title = "";
  let meta = [] as PageMetadata[];
  const links = [
    {
      rel: "shortcut icon",
      type: "image/png",
      href: favicon,
    },
  ] as PageLinks[];

  const page = Scrivito.currentPage();
  if (page) {
    lang = page.language() || "en";
    title = (page.get("title") as string) || "";
    meta = getMetadata(page);
    links.push({ rel: "canonical", href: Scrivito.urlFor(page) });
  }

  const htmlAttributes = { lang };

  return (
    <Helmet
      meta={meta}
      htmlAttributes={htmlAttributes}
      title={title}
      link={links}
    />
  );
});
